import { v4 as uuidv4 } from 'uuid';
import React, { useState, useCallback, useMemo } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import {
  makePHPRequest,
  methodNameEnum,
} from '../../recoil/selectors/makePHPRequest';
import moment from 'moment-timezone';
import { DateTime } from 'luxon';
import { Role, user } from '../../recoil/atoms/user';
import { Paper, Switch, FormControlLabel, FormGroup } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { DataTable } from '../modules/Manage/pages/queues-table/DataTable';
import { EnhancedTableToolbar } from '../modules/Manage/pages/queues-table/EnhancedTableToolbar';
import dataTableScss from '../modules/Manage/pages/queues-table/data-table.module.css';

import { permissionsSelector } from '../../recoil/selectors/permissionsSelector';

const useStyles = makeStyles((theme) => ({
  field: {
    marginTop: theme.spacing(1), // space between fields
    marginBottom: theme.spacing(1), // space between fields
    backgroundColor: theme.palette.mode === 'dark' ? '#3a3a3a' : '#f6f6f6',
  },
}));
export function RecurringInvoice({
  businessData,
  businessProducts,
  billingCycleTotal,
}) {
  const classes = useStyles();
  const [filter, setFilter] = useState(false);
  const userAtom = useRecoilValueLoadable(user);
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents;
  const isSuperAdminBoolean = role === Role.SUPERADMIN;
  const billingStatus = useRecoilValueLoadable(
    makePHPRequest({
      methodName: methodNameEnum.GET_BILLING_STATUS,
      payloadJsonString: JSON.stringify({
        businessid: userAtom?.contents?.businessid,
      }),
    })
  );

  // const billDayMemo = useMemo(() => {
  //   let billDay;
  //   if (
  //     businessData.state === 'hasValue' &&
  //     businessData?.contents?.response?.data
  //   ) {
  //     if (
  //       moment().date() <=
  //         businessData.contents?.response?.data?.result[0]?.billDay ??
  //       ''
  //     ) {
  //       billDay = moment()
  //         .set(
  //           'date',
  //           businessData.contents?.response?.data?.result[0]?.billDay ?? ''
  //         )
  //         .tz(businessData.contents?.response?.data?.result[0]?.timezone_php)
  //         .format('MM/DD/YY');
  //     } else {
  //       billDay = moment()
  //         .set(
  //           'date',
  //           businessData.contents?.response?.data?.result[0]?.billDay ?? ''
  //         )
  //         .tz(businessData.contents?.response?.data?.result[0]?.timezone_php)
  //         .add(1, 'month')
  //         .format('MM/DD/YY');
  //     }
  //   } else {
  //     billDay = 'unknown';
  //   }
  //   return billDay;
  // }, [businessData]);

  const businessProductsMemo = useMemo(() => {
    if (businessProducts.state === 'hasValue') {
      return businessProducts?.contents?.map((a) => ({
        ...a,
        id: uuidv4(),
        totalamt: parseFloat(a.totalamt.split('$')[1]),
      }));
    } else {
      return [];
    }
  }, [businessProducts]);

  const rows = useMemo(() => {
    const cardDeclined =
      billingStatus.contents?.data?.result?.result?.cardDeclined;
    const clonedBusinessProducts = [...businessProductsMemo];
    if (
      businessData.state === 'hasValue' &&
      billingStatus.state === 'hasValue' &&
      businessProducts.state === 'hasValue'
    ) {
      for (let i = 0; i < clonedBusinessProducts?.length; i++) {
        if (cardDeclined === 1) {
          clonedBusinessProducts[i].invoiceduntil = 'Card Declined';
        }
        if (
          clonedBusinessProducts[i].invoiceduntil === '00-00-0000' ||
          clonedBusinessProducts[i].invoiceduntil === '0000-00-00'
        ) {
          if (
            moment().date() >=
              businessData?.contents?.response?.data?.result?.[0]?.billDay ??
            ''
          ) {
            clonedBusinessProducts[i].invoiceduntil = moment()
              .set(
                'date',
                businessData?.contents?.response?.data?.result?.[0]?.billDay ??
                  ''
              )
              .tz(
                businessData?.contents?.response?.data?.result?.[0]
                  ?.timezone_php
              )
              .format('YYYY-MM-DD');
          } else {
            clonedBusinessProducts[i].invoiceduntil = moment()
              .set(
                'date',
                businessData?.contents?.response?.data?.result?.[0]?.billDay ??
                  ''
              )
              .tz(
                businessData?.contents?.response?.data?.result?.[0]
                  ?.timezone_php
              )
              .add(1, 'month')
              .format('YYYY-MM-DD');
          }
        }
        if (
          (businessData?.contents?.response?.data?.result?.[0]?.discountEndDate?.substring?.(
            0,
            10
          ) >=
            moment(clonedBusinessProducts[i].invoiceduntil).format(
              'YYYY-MM-DD'
            ) ||
            !businessData?.contents?.response?.data?.result?.[0]
              ?.discountEndDate) &&
          !!clonedBusinessProducts[i].canHaveDiscount &&
          !!businessData?.contents?.response?.data?.result?.[0]
            ?.discountPercent &&
          clonedBusinessProducts[i].status === 'active'
        ) {
          clonedBusinessProducts[i].totalamt = (
            ((100 -
              (businessData?.contents?.response?.data?.result?.[0]
                ?.discountPercent ?? 0)) /
              100) *
            clonedBusinessProducts[i].totalamt
          ).toFixed(2);
        }
      }
      return clonedBusinessProducts.filter((val) =>
        !filter
          ? val.totalamt !== '0.00' &&
            val.totalamt !== '$0.00' &&
            val.totalamt !== 0
          : val
      );
    } else {
      return [];
    }
  }, [billingStatus, businessProductsMemo, businessData, filter]);
  const startDateFormatter = (params) =>
    DateTime.fromISO(params.value, {
      zone: businessData?.contents?.response?.data?.result?.[0]?.timezone_php,
    }).toLocaleString(DateTime.DATETIME_SHORT);
  const billingCycleFormatter = (params) => {
    return `${params.value} Months`;
  };
  /*moment(params.value)
      .tz(businessData.contents?.response?.data?.result[0]?.timezone_php)
      .toLocaleString('YYYY-MM-DD hh:mm:ss');*/
  const columns = [
    {
      field: 'pdescription',
      headerName: 'Product',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      // hidden: true // hide field but still searchable
    },
    {
      field: 'startdate',
      headerName: 'Start Date',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      valueFormatter: startDateFormatter,
    },
    {
      field: 'paymentduration',
      headerName: 'Billing Cycle',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      valueFormatter: billingCycleFormatter,
    },
    {
      field: 'units',
      headerName: 'Units',
      headerClassName: dataTableScss.fullWidth + ' superStyle',
      cellClassName: dataTableScss.fullWidth,
      hide: !isSuperAdminBoolean,
      disableExport: !isSuperAdminBoolean,
    },
    {
      field: 'totalamt',
      headerName: 'Price Per',
      headerClassName: dataTableScss.fullWidth,
      cellClassName: dataTableScss.fullWidth,
      valueFormatter: (params) => {
        return '$' + params.row.totalamt;
      },
    },
    {
      field: 'invoiceduntil',
      headerName: 'Current Until',
      valueFormatter: (params) =>
        !!params.value?.length
          ? moment(params.value || undefined)?.format('MM/DD/YYYY')
          : '',
      // renderCell: currentUntilFormatter,
    },
  ];
  const ToolbarComponent = useCallback(
    (props) => (
      <EnhancedTableToolbar
        {...props}
        dataType="Subscription"
        // centerComponent={
        //   <>
        //     {role === Role.SUPERADMIN && (
        //       <div> Next Subscription will be billed on: {billDayMemo} </div>
        //     )}
        //   </>
        // }
        leftComponent={
          isSuperAdminBoolean && (
            <FormGroup
              className="superStyle"
              style={{ margin: '0 0 auto auto', paddingLeft: '6px' }}
            >
              <FormControlLabel
                label="Include $0.00 charges"
                className="mb-0"
                control={
                  <Switch
                    color="primary"
                    type="checkbox"
                    checked={filter}
                    inputProps={{ 'aria-label': 'controlled' }}
                    onChange={() => setFilter((cur) => !cur)}
                  />
                }
              />
            </FormGroup>
          )
        }
        hideSearch={true}
      />
    ),
    [businessData, classes, role, billingCycleTotal, filter]
  );
  return (
    <>
      <Paper square={true} elevation={0}>
        <DataTable
          rows={rows?.reverse()}
          columns={columns}
          sortModel={[{ field: 'pdescription', sort: 'asc' }]}
          ToolbarComponent={ToolbarComponent}
          loading={businessProducts.state === 'loading'}
        />
      </Paper>
    </>
  );
}
